import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { UserService } from '@app-services/user/user.service';
import { TenantConstant } from '@app-constants/tenant.constant';
import { openTSDialog } from 'src/app/helpers/methods';
import { openDefaultLoginDialog, openTermsAndConditionsDialog, signup, socialMediaClicked } from '@app-core/components/home/home.component';
import { SignupService } from '@app-services/signup/signup.service';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';

@Component({
  selector: 'app-special-series',
  templateUrl: './special-series.component.html',
  styleUrls: ['./special-series.component.css']
})
export class SpecialSeriesComponent implements OnInit {
  @ViewChild('content') public content: any;
  signup = signup;
  openDefaultLoginDialog = openDefaultLoginDialog;
  openTermsAndConditionsDialog = openTermsAndConditionsDialog;
  socialMediaClicked = socialMediaClicked;
  openTSDialog = openTSDialog;
  mobileNumberForm: FormGroup;
  mobileNumberValid = false;
  tenant: any = TenantConstant.tenant;
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public modalservice: NgbModal,
    private fb: FormBuilder,
    public userService: UserService,
    public signUpService: SignupService, private dialog: MatDialog, private gaService: GAnalyticsService, public subscriptionservice : SubscriptionService) { }

  ngOnInit(): void {
    this.mobileNumberForm = this.fb.group({
      mobilenumber: ['', [Validators.required, Validators.pattern(/^(?:(?:\+|0{0,2})91(\s*[\ -]\s*)?|[0]?)?[6789]\d{9}|(\d[ -]?){10}\d$/)]]
    })
    this.titleService.setTitle('Free Online Test Series for NEET and JEE 2021 | Infinity Learn');
    this.metaService.addTags([
      {name: 'keywords', content: 'NEET test series, test series for neet, jee advanced test series, neetprep test series, best test series for neet, neet test series free, neet online test series free, online test series for neet, best online test series for neet, ncert based test series for neet, best test series for jee, best online test series for jee, best test series for jee advanced, best test series for iit jee, Jee advanced mock test, jee advanced online test series, Jee advanced free mock test'},
      {name: 'description', content: 'Enroll in the leading test series program for JEE and NEET 2021. This test series is built focusing on the real test pattern and most important questions to help you crack the exams.'},
    ])

  }
  openSignUpDialog(noNumber = false): void {

    const dialogRef = this.openTSDialog({
      message: 'One more step and you are all set',
        source: 'Specialseries',
        phone: noNumber ? '': this.mobileNumberForm.value.mobilenumber,
        countryCode: '+91',
        panelClass: ['neet-live-class', 'spl-series'],
        hiddenFields: {state: true, hallticket: true},
        exam: 'JEEADVANCED',
        isJEE: true
    })
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result) {
        this.modalservice.open(this.content)
      }
    });
  }
  onInputChange() {

    let Value = this.mobileNumberForm.value.mobilenumber;
    let stringLength = String(Value).length;
    if (Value && stringLength > 10) {
      let newValue = parseInt(String(Value).slice(0, 9));
      this.mobileNumberForm.value.mobilenumber = newValue;
    }

    if (stringLength > 8 && this.mobileNumberForm.valid) {
      this.mobileNumberValid = true;
    } else {
      this.mobileNumberValid = false;
    }
  }

  ngOnDestroy(){
  }
}
